/**
 * startupProbe.js
 *
 * Runs once at app start and prints a clear diagnosis to the browser console:
 *   [Startup Probe] CORS     – server replied but blocked by CORS policy
 *   [Startup Probe] TIMEOUT  – no reply within the probe window
 *   [Startup Probe] NETWORK  – DNS / TCP unreachable (offline or wrong URL)
 *   [Startup Probe] OK       – server is reachable and CORS is fine
 *
 * Uses a lightweight OPTIONS preflight to the /api/auth/ping endpoint
 * (falls back gracefully if that endpoint doesn't exist – a 404 still proves
 * CORS is NOT the problem).
 */

const PROBE_URL =
  (process.env.REACT_APP_API_URL || "https://backend-qureo-production-fab5.up.railway.app") +
  "/api/auth/ping";

const PROBE_TIMEOUT_MS = 10_000; // 10 s – enough for a cold Render spin-up

const TAG = "%c[Startup Probe]";
const STYLES = {
  ok:      "color:#22c55e;font-weight:bold",
  cors:    "color:#f97316;font-weight:bold",
  timeout: "color:#eab308;font-weight:bold",
  network: "color:#ef4444;font-weight:bold",
  info:    "color:#60a5fa;font-weight:bold",
};

export async function runStartupProbe() {
 
}
